<groundworks-card class="h-100" [cardClasses]="['h-100']" [title]="'Sales Touchpoints'">
  <groundworks-card-body class="d-flex flex-column h-100">
    <div class="flex-grow-1 overflow-y-auto min-h-0">
      @switch (getState()) {
      @case ('loading') {
      <groundworks-state-message type="loading" message="Loading Sales Touchpoints..." class="d-flex" />
      }
      @case ('no-matches') {
      <groundworks-state-message type="no-matches" message="No Sales Touchpoints Found." class="d-flex" />
      }
      @case ('error') {
      <groundworks-state-message type="error" message="Error loading Sales Touchpoints." class="d-flex" />
      }
      @case ('matches') {
      @for (touchPoint of touchPoints(); track touchPoint.id) {
      <div class="mb-4 pb-3">
        <div class="mb-2">
          <span class="fw-bold">{{ touchPoint.userName }}</span>
          @if (touchPoint.sourceName) {
          <span class="text-muted ms-2">- {{ touchPoint.sourceName }}</span>
          }
          <small class="text-muted ms-2">{{ getTimeAgo(touchPoint.createdAt) }}</small>
        </div>
        <p class="mb-0">{{ touchPoint.note }}</p>
      </div>
      }
      }
      }
    </div>

    <div class="pt-4">
      <div class="mb-3">
        <textarea class="form-control" id="sales-touchpoint-note" rows="3"
          placeholder="Add a comment about this sale"></textarea>
      </div>
      <div class="d-flex justify-content-end">
        <groundworks-loading-button (click)="onAddTouchpoint()" (keydown.enter)="onAddTouchpoint()" [label]="'Add Note'"
          [loading]="isAddingTouchpoint()" />
      </div>
    </div>
  </groundworks-card-body>
</groundworks-card>
